









































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/requestExt'
import navigater from '@/components/navigater.vue'

export default Vue.extend({
    components: {
        navigater,
    },
    data() {
        return {
            id: '',
            loading: true,
            navTitle: '',
            imageData: [
            ],
            dataObj: {},
            xingIndex: 0,
            comment: '',
        }
    },
    created() {
        this.id = this.$route.params.id
        this.getData(this.id)
    },
    methods: {
        getData(id: any) {
            request.get(`/api/class_info/${id}`).then((result) => {
                console.log(result)
                this.navTitle = result.name // 班级名称
                this.dataObj = result
                this.loading = false
            }).catch((err) => {
                console.log(err)
                this.loading = false
            })
        },
        changeXing(item: any) {
            this.xingIndex = item
        },
        submit() {
        if (this.xingIndex < 1) {
            this.$Message.error('请选择评分')
            return
        }

        if (this.comment === '') {
            this.$Message.error('请输入评价')
            return
        }
        const params = {
            score: String(this.xingIndex*20),
            comment: this.comment,
            classId: this.id,
        }

        this.$Modal.confirm({
            title: '请确认提交',
            content: '<p>您仅可对此培训班评价一次</p><p>该评价提交后不支持删除和修改</p>',
            onOk: () => {
                request.post('/api/classEva/evaluate', params)
                    .then((res) => {
                            this.$Message.success('保存成功!')
                            this.$router.replace('/main/user')
                    }).catch((err) => {
                this.$Message.error(err)
            })
            },
            onCancel: () => {
                this.$Message.info('取消提交');
            },
        });
        },

    },
    filters: {
        getTime(value: any) {
            if (value) {
                return moment(value).format('YYYY/MM/DD HH:mm:ss')
            } else {
                return '- -'
            }
        },
    },
})
